import React from "react";

interface Props {}

const AuthLoading = (props: Props) => {
  return <div>Authentication in progress...</div>;
};

export default AuthLoading;
